
//action types 
export const CATEGORIES_ACTION_TYPES = {
    SET_CATEGORIES: 'SET_CATEGORIES'
  }
  